import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Spin } from 'antd'
import MyRadio from '../../components/forms/radio'
import MyTextArea from '../../components/forms/textArea'
import MyInput from '../../components/forms/input'

const AuditPresentationApplication = (props) => {
    const [formValue, setFormValue] = useState({
        auditStatus: props.data.auditStatus,
        failureReason: props.data.failureReason
    })
    const [errorMsg, setErrorMsg] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const handleOk = () => {
        setErrorMsg({})
        setIsLoading(true)
        axios.post('/admin/campus_presentation/audit', {
            application_id: props.data.id,
            audit_status: formValue.auditStatus,
            audit_person: formValue.auditPerson,
            audit_remark: formValue.auditRemark
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('审核完成！')
                    props.isCancel()
                    props.getPresentationDetail()
                    props.getApplicationData()
                    setIsLoading(false)
                } else {
                    message.error(response.msg)
                    setIsLoading(false)
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <Modal
            title="审核"
            open={props.isOpen}
            onOk={handleOk}
            onCancel={props.isCancel}
            cancelText="取消"
            okText="保存">

            <Spin spinning={isLoading} tip='审核中，请稍等'>
                <MyRadio
                    id='auditStatus'
                    label='请选择'
                    options={[
                        {
                            label: '待审',
                            value: 1,
                        },
                        {
                            label: '审核通过',
                            value: 2,
                        },
                        {
                            label: '审核未通过',
                            value: 3,
                        }
                    ]}
                    value={formValue.auditStatus}
                    onChange={setFormValue}
                />

                <MyInput
                    id="auditPerson"
                    maxLength={64}
                    label='审核人'
                    placeholder='请输入审核人'
                    value={formValue.auditPerson}
                    onChange={setFormValue}
                />

                <MyTextArea
                    id="auditRemark"
                    label='审核备注'
                    minRows={3}
                    placeholder='请输入审核备注'
                    value={formValue.auditRemark}
                    onChange={setFormValue}
                    errorMsg={errorMsg.auditRemark}
                />
            </Spin>
        </Modal>
    )
}

export default AuditPresentationApplication
